const config = {
  name: "dillon",
  features: {
    accessCodes: false,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: false,
    userPhoneNumber: true,
    userName: false,
    showAdaSupport: true,
    userPostalCode: false
  },
  parkingSession: {
    // Until 2 PM the day before (24 hours before)
    cancelDaysBefore: 1,
    cancelTime: "14:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 10 am
    startOffsetHrs: 14,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 300
  }
}
export default config
